module.exports = __webpack_public_path__ + "static/img/bg-tr.f4200d44.png";